<div class="c-internet">
  <div class="row">
    <div class="col-12">
      <img :src="require('@/assets/icons/sidebars/no-internet.svg')" alt="" />
    </div>
  </div>
  <div class="c-internet-title">
    <span class="name">{{ $t('errorInternet') }}</span>
    <span class="desc">{{ $t('errorInternetMessage') }}</span>
  </div>
</div>
<!-- No Internet connection found. Check your connection or try again. -->
